module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><legend>'+
((__t=( i18n.tc("SubscriptionTerminate", "Terminate subscription") ))==null?'':__t)+
'</legend><p>'+
((__t=( i18n.tc("SubscriptionTerminate", "Would you like to continue using %1$s until the current subscription expiration date %2$s, or would you like to terminate it immediately?").format( transientAlias, "<strong>" + renewalDate + "</strong>" ) ))==null?'':__t)+
'</p><div data-container="radio-array"><div><input type="radio" name="radio" data-input="choice-radio" id="deactivate"> <label class="align-left" for="deactivate">'+
((__t=( i18n.tc("SubscriptionTerminate", "Stop subscription on %s.").format(renewalDate) ))==null?'':__t)+
'</label></div><div><input type="radio" name="radio" data-input="choice-radio" id="terminate"> <label class="align-left" for="terminate">'+
((__t=( i18n.tc("SubscriptionTerminate", "Stop the subscription immediately.") ))==null?'':__t)+
'</label></div></div></fieldset><fieldset class="button-wrap"><button data-click="choice-cancel">'+
((__t=( i18n.tc("SubscriptionTerminate", "Cancel") ))==null?'':__t)+
'</button> <button class="danger" data-click="choice-submit" disabled="disabled">'+
((__t=( i18n.tc("SubscriptionTerminate", "Next") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
